import { render } from "./BankAccount0Ec.vue?vue&type=template&id=1a1d2e44&scoped=true"
import script from "./BankAccount0Ec.vue?vue&type=script&lang=js"
export * from "./BankAccount0Ec.vue?vue&type=script&lang=js"

import "./BankAccount0Ec.vue?vue&type=style&index=0&id=1a1d2e44&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a1d2e44"]])

export default __exports__